export default {
    //商户有码商
    MER_ROLE_WITH_DEVICE: "1125076279838638080",
    //商户无码商
    MER_ROLE_WITH_NO_DEVICE: "1125070436338499584",
    //一级代理商有码商
    FIRST_AGENT_ROLE_WITH_DEVICE: "1125409954740568064",
    //一级代理无码商
    FIRST_AGENT_ROLE_WITH_NO_DEVICE: "1125410685723869184",
    //二级代理有码商
    SECOND_AGENT_ROLE_WITH_DEVICE: "1125414162776719360",
    //二级代理无码商
    SECOND_AGENT_ROLE_WITH_NO_DEVICE: "1125414473465593856"
}